<template>
	<div>
		<div class="view-container">
			<div class="view-btn">
				<input
					id="view-queue"
					v-model="view_options.queue"
					type="checkbox"
					@change="view_change"
				/>
				<label for="view-queue">My Queue</label>
			</div>

			<div class="view-btn">
				<input
					id="view-unpicked"
					v-model="view_options.unpicked"
					type="checkbox"
					@change="view_change"
				/>
				<label for="view-unpicked">Unpicked Players</label>
			</div>
			<div class="view-btn">
				<input
					id="view-picked"
					v-model="view_options.picked"
					type="checkbox"
					@change="view_change"
				/>
				<label for="view-picked">Drafted Players</label>
			</div>
		</div>
		<div class="flex justify-center">
			<Dropdown title="Position" />
			<Dropdown title="Team" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
.view-container {
	@apply flex h-10 justify-center items-center text-xs md:text-base;

	.view-btn label {
		@apply bg-white text-blue-500 border-blue-500 hover:bg-blue-300 hover:text-white border;
		@apply px-4 py-2 md:mx-0 outline-none h-28;

		cursor: pointer;
	}

	.view-btn:first-child label {
		@apply border-r-0 rounded-l-lg rounded-r-none;
	}

	.view-btn:last-child label {
		@apply border-l-0 rounded-r-lg rounded-l-none;
	}

	input[type='checkbox'] {
		display: none;

		&:checked + label {
			@apply bg-blue-500 text-white border 
			hover:bg-blue-400 hover:text-white;
		}
	}
}
</style>

<script>
import Dropdown from '@/components/common/Dropdown';

export default {
	components: { Dropdown },
	props: {
		on_view_change: { type: Function },
		view_options: {
			type: Object,
			default: function () {
				return { queue: true, unpicked: true, picked: false };
			},
		},
	},
	mounted() {
		this.on_view_change(this.view_options);
	},
	methods: {
		view_change() {
			this.on_view_change(this.view_options);
		},
	},
};
</script>
